<template>
    <div class="tips-wrapper" :style="styleObj">
        {{ text }}
    </div>
</template>

<script>
/**
 * text: String, left: int, top: int
 */
export default {
    name: "Tips",
    props: ["text", "left", "top"],
    computed: {
        styleObj() {
            let style = {};

            if (this.left) {
                style.left = this.left + "px";
            }

            if (this.top) {
                style.top = this.top + "px";
            }

            return style;
        }
    }
};
</script>

<style lang="less" scoped>
.tips-wrapper {
    position: absolute;
    color: #fff;
    background: #333333;
    border-radius: 4px;
    font-size: 12px;
    height: 30px;
    padding: 0 8px;
    left: -11px;
    line-height: 30px;
    bottom: -30px;
    text-align: center;
    white-space: nowrap;
    z-index: 1;
}
</style>
